/**
 * Complete API Service Module
 * Contains ALL API service methods needed by the application
 * Refactored to use modular service classes
 */

import apiClient from "./apiClient";
import authService from "../auth/AuthService";
import userService from "features/account/services/UserService";
import courseService from "features/courses/services/CourseService";
import tutorialService from "features/tutorials/services/TutorialService";
import reviewService from "features/courses/services/ReviewService";
import bookmarkService from "features/courses/services/BookmarkService";
import teacherService from "features/teachers/services/TeacherService";
import stripeConnectService from "features/payments/services/StripeConnectService";
import purchaseService from "features/payments/services/PurchaseService";
import enrollmentService from "features/courses/services/EnrollmentService";
import ProgressService from "services/ProgressService";
import MultitrackService from "features/multitracks/services/MultitrackService";
import dashboardService from "features/dashboard/services/DashboardService";
import uploadService from "./UploadService";
import categoryService from "features/courses/services/CategoryService";
import CommentService from "features/feed/services/CommentService";
import StoryService from "features/feed/services/StoryService";

// Re-export the modern API client as default
const api = apiClient;

// Complete apiService object with ALL services
export const apiService = {
  auth: authService,
  users: userService,
  courses: courseService,
  tutorials: tutorialService,
  reviews: reviewService,
  bookmarks: bookmarkService,
  teachers: teacherService,
  stripeConnect: stripeConnectService,
  purchases: purchaseService,
  enrollments: enrollmentService,
  progress: ProgressService,
  multitracks: MultitrackService,
  dashboard: dashboardService,
  uploads: uploadService,
  categories: categoryService,
  comments: CommentService,
  stories: StoryService,
};

export default api;
